module.exports = __webpack_public_path__ + "img/logo.3afeb648.svg";